import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Client } from 'src/app/model/client';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  baseUrl = environment.apiUrl
  constructor(private http:HttpClient) {}

  getClients():Observable<Client[]>{
    return this.http.get<Client[]>(this.baseUrl+"/api/clients");
  }
}
